import { post } from 'config/api'

const headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
}

export const AuthService = {
    login: (params) => post(`/v1/oauth/token`, params, headers)
}